import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";

import imgAS from "../../assets/image/l6/png/l6-download-appstore.png";
import imgGP from "../../assets/ecom/logo_black.png";

const Footer = () => {
  return (
    <>
      <div className="footer-section pt-17 pt-lg-21">
        <Container>
          <div className="footer-top pb-lg-14">
            <Row>
              <Col xs="6" lg="2">
                <div className="single-footer mb-13 mb-lg-9">
                  <p className="footer-title gr-text-11 mb-7">Company</p>
                  <ul className="footer-list list-unstyled">
                    <li className="py-2">
                      <Link
                        to="/#about-us"
                        className="gr-text-9 gr-text-color gr-hover-text-red"
                      >
                        About us
                      </Link>
                    </li>
                    <li className="py-2">
                      <Link
                        to="/#our-services"
                        className="gr-text-9 gr-text-color gr-hover-text-red"
                      >
                        Our Services
                      </Link>
                    </li>
                    <li className="py-2">
                      <Link
                        to="/#enquire-now"
                        className="gr-text-9 gr-text-color gr-hover-text-red"
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>

              <Col xs="12" lg="4">
                <div className="single-footer mb-13 mb-lg-9">
                  <p className="footer-title gr-text-11 mb-7">Legal</p>
                  <ul className="footer-list list-unstyled">
                    <li className="py-2">
                      <Link
                        to="/privacy-policy"
                        className="gr-text-9 gr-text-color gr-hover-text-red"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li className="py-2">
                      <Link
                        to="/terms-and-conditions"
                        className="gr-text-9 gr-text-color gr-hover-text-red"
                      >
                        Terms &amp; Conditions
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col xs="6" lg="3" className="offset-lg-2">
                <div className="single-footer mb-13 mb-lg-9">
                  <div className="download-block">
                    <div className="download-btns">
                      <img src={imgGP} alt="" width="200" />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div className="copyright-area border-top py-9">
            <Row className="align-items-center">
              <Col lg="6">
                <p className="copyright-text gr-text-11 mb-6 mb-lg-0 gr-text-color text-center text-lg-left">
                  © 2020 Copyright, All Right Reserved, Made by The Ecom Agency
                  with
                  <i className="icon icon-heart-2-2 text-red align-middle ml-2"></i>
                </p>
              </Col>
              <Col lg="6" className="text-center text-lg-right">
                <ul className="social-icons list-unstyled mb-0">
                  <li className="ml-7">
                    <a href="https://www.facebook.com/EcomAgencyHQ" className="gr-text-color gr-hover-text-red" target="_blank" title='Ecom Agency Facebook'>
                      <i className="icon icon-logo-facebook"></i>
                    </a>
                  </li>
                  <li className="ml-7">
                    <a href="https://www.instagram.com/ecomagencyhq/" className="gr-text-color gr-hover-text-red" target="_blank" title="Ecom Agency Instagram">
                      <i className="icon icon-instant-camera-2"></i>
                    </a>
                  </li>
                  <li className="ml-7">
                    <a href="https://www.linkedin.com/company/ecom-agency-hq/" className="gr-text-color gr-hover-text-red" target="_blank" title="Ecom Agency LinkedIn">
                      <i className="icon icon-logo-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Footer;
